import { render, staticRenderFns } from "./search.vue?vue&type=template&id=b3db6468&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchLayeredNavigation: require('/~/src/modules/opus-ecom/components/Search/SearchLayeredNavigation.vue').default})
